import {
  fetchLinkedEntities,
  clearLinkedEntities,
} from '../../routines/linkedEntityRoutine';

const initialState = {
  loadingLinkedEntity: false,
  linkedEntities: {
    organization: {},
    account: {},
    contact: {},
    pipeline: {},
  },
};

const linkedEntityReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchLinkedEntities.TRIGGER: {
      return {
        ...state,
        loadingLinkedEntity: true,
      };
    }
    case fetchLinkedEntities.SUCCESS: {
      const { level, data, entityId } = action.payload;
      return {
        ...state,
        loadingLinkedEntity: false,
        linkedEntities: {
          ...state.linkedEntities,
          [level]: {
            ...state.linkedEntities[level],
            [entityId]: data,
          },
        },
      };
    }
    case fetchLinkedEntities.FAILURE: {
      return {
        ...state,
        loadingLinkedEntity: false,
      };
    }
    case clearLinkedEntities.TRIGGER: {
      return initialState;
    }
    default:
      return state;
  }
};

export default linkedEntityReducer;
